import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import CookiePolicy from "@/pages/CookiePolicy";
import ExperienceDetail from "@/pages/ExperienceDetail";
import BuildYourEvening from "@/pages/BuildYourEvening";
import CookieBanner from "@/components/CookieBanner";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import { initGA } from "@/lib/analytics";

function App() {
  useEffect(() => { initGA(); }, []);
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/experiences/:slug" element={<ExperienceDetail />} />
            <Route path="/build-your-evening" element={<BuildYourEvening />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-center" />
      </LanguageProvider>
    </div>
  );
}

export default App;
